<template>
<div>
  <news-flash-title></news-flash-title>
</div>
</template>

<script>
import NewsFlashTitle from "@/components/newsFlash/newsFlashTitle";
export default {
  name: "newsFlash",
  components: {NewsFlashTitle}
}
</script>

<style scoped>

</style>
